import ContactUs from '@/components/ContactUs';
import { Tit } from '@/components/Titles';
import React, { FC } from 'react';
import styled from 'styled-components';

const contactData = [
  {
    id: 1,
    tit: `문의`,
    costumer: `후원자모집팀`,
    tel: `02-721-5142`,
    email: `igshop@unicef.or.kr`,
  },
];

const StepContainer = styled.div`
  padding-top: 32px;

  .dec {
    margin-top: 32px;
    margin-bottom: 72px;
  }
`;

const PartyAppyComplete: FC = () => (
  <StepContainer>
    <Tit size="s1-5" color="sky" weight="normal">
      Party for UNICEF <br />
      신청이 완료되었습니다.
    </Tit>
    <p className="dec">
      신청 결과는 7~10일 이내에 심사를 통해 담당자가 안내드릴 예정입니다. <br />
      허가 후, 파티 시작 1주 전에 키트를 발송해드립니다. <br />
      유니세프를 알리고 어린이들의 꿈을 이루는 데에 동참해주셔서 감사합니다.
    </p>
    <ContactUs itemData={contactData} />
  </StepContainer>
);
export default PartyAppyComplete;
